import {
  GRID_DETAIL_PANEL_TOGGLE_FIELD,
  GridInitialState,
} from "@mui/x-data-grid-pro";
import { GridPersistenceConfig } from "components/RATDataGrid";
import { TableSummaryGridField } from "./tableSummaryGrid.columns";

export const TABLE_SUMMARY_GRID_STATE_STORAGE_KEY = "tableSummary.gridState";

export const TABLE_SUMMARY_GRID_DEFAULT_INITIAL_STATE: GridInitialState = {
  columns: {
    columnVisibilityModel: {
      [TableSummaryGridField.TableId]: false,
      [TableSummaryGridField.CompareId]: false,
      [TableSummaryGridField.OwnerTool]: false,
    },
    orderedFields: [
      GRID_DETAIL_PANEL_TOGGLE_FIELD,
      TableSummaryGridField.Actions,
      TableSummaryGridField.TableId,
      TableSummaryGridField.CompareId,
      TableSummaryGridField.TableType,
      TableSummaryGridField.Rulesets,
      TableSummaryGridField.LookupProperties,
      TableSummaryGridField.DependencyProperties,
      TableSummaryGridField.RowCount,
      TableSummaryGridField.ValidationErrorCount,
      TableSummaryGridField.ValidationWarningCount,
      TableSummaryGridField.ValidationInfoCount,
      TableSummaryGridField.Comments,
      TableSummaryGridField.Sources,
      TableSummaryGridField.OwnerTool,
    ],
  },
  pinnedColumns: {
    left: [GRID_DETAIL_PANEL_TOGGLE_FIELD, TableSummaryGridField.Actions],
  },
  sorting: {
    sortModel: [],
  },
  filter: {
    filterModel: {
      items: [],
      quickFilterValues: [],
    },
  },
  density: "compact",
};

export const TABLE_SUMMARY_GRID_PERSISTENCE: GridPersistenceConfig = {
  storageKey: TABLE_SUMMARY_GRID_STATE_STORAGE_KEY,
  validFields: [
    GRID_DETAIL_PANEL_TOGGLE_FIELD,
    ...Object.values(TableSummaryGridField),
  ],
  defaultInitialState: TABLE_SUMMARY_GRID_DEFAULT_INITIAL_STATE,
  ensureFirstFields: [
    GRID_DETAIL_PANEL_TOGGLE_FIELD,
    TableSummaryGridField.Actions,
  ],
  defaultPinnedLeft: [
    GRID_DETAIL_PANEL_TOGGLE_FIELD,
    TableSummaryGridField.Actions,
  ],
};
